import KaModal from './KaModal';
import Button from './Button';
import SpinnerButton from './SpinnerButton';

interface ConfirmProps {
  visible: boolean;
  title: string;
  body: string;
  confirmStyle?: 'danger' | 'primary'
  loading?: boolean;
  onDismiss: () => void;
  onConfirm: () => void;
}

const Confirm = (props: ConfirmProps) => {
  const confirmStyle = props.confirmStyle ?? 'danger';

  return (<KaModal
    isOpen={props.visible}
    title={props.title}
    body={props.body}
    footer={
      <div className="container">
        <div className="row justify-content-between">
          <Button className='col-3 btn-secondary' onClick={props.onDismiss} disabled={props.loading ?? false}>Cancel</Button>
          <SpinnerButton
            className={`col-3 btn-${confirmStyle}`}
            onClick={props.onConfirm}
            spinning={props.loading ?? false}>
            Yes
          </SpinnerButton>
        </div>
      </div>
    }
  />)
};

export default Confirm;